import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

export const variableHighlightPluginKey = new PluginKey('variableHighlight');

export const variableHighlightPlugin = new Plugin({
  key: variableHighlightPluginKey,
  props: {
    decorations(state) {
      const decorations: Decoration[] = [];
      state.doc.descendants((node, pos) => {
        if (node.isText && node.text) {
          const regex = /\{\{[^}]+\}\}/g;
          let match;
          while ((match = regex.exec(node.text)) !== null) {
            decorations.push(
              Decoration.inline(pos + match.index, pos + match.index + match[0].length, {
                class: 'bn-variable-highlight',
              })
            );
          }
        }
      });
      return DecorationSet.create(state.doc, decorations);
    },
  },
});
